import { ReactElement, useContext } from 'react'
import { isNestedRouteAllowedForRole } from 'src/routing/routing-utils'
import { NotAuthorized } from 'src/shared/not-authorized/NotAuthorized'
import { UserContext } from 'src/user/UserContext'
import { SecondLevelRoute } from 'src/routing/routing'

export const RestrictedNestedRoute = ({
  nestedRoute,
  component: Component,
  ...forwardProps
}: {
  nestedRoute: SecondLevelRoute
  component: React.FC
}): ReactElement => {
  const { user } = useContext(UserContext)

  if (user.roles.length > 0) {
    const { roles } = user

    if (nestedRoute && isNestedRouteAllowedForRole(nestedRoute, roles)) {
      return <Component {...forwardProps} />
    } else {
      return <NotAuthorized inSecondLevelNavigationTab />
    }
  }

  return <NotAuthorized inSecondLevelNavigationTab />
}
